import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_RESOLVE_PROOFREADER_COMMENT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { vendorResolveProofreaderFailure, vendorResolveProofreaderSuccess } from '../actions';

const VendorProofreaderCommentAPI = (action) => postApiRequest(VENDOR_RESOLVE_PROOFREADER_COMMENT_API_URL, action);

function* handleVendorProofreaderComment(action) {
  try {
    const response = yield call(VendorProofreaderCommentAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(vendorResolveProofreaderSuccess(response));
  } catch (error) {
    yield put(vendorResolveProofreaderFailure(error));
  }
}

export function* watchVendorProofreaderComment() {
  yield takeLatest(types.VENDOR_RESOLVE_PROOFREADER_REQUEST, handleVendorProofreaderComment);
}
